(function () {
  var HEADER_PATTERNS = [
    { key: "benefits", re: /^(key benefits|the benefits|benefits|what you'll love|why you'll love it|why you'll love this|what you will love|highlights)\b/i },
    { key: "ingredients", re: /^(key ingredients|hero ingredients|the ingredients|star ingredients|ingredients|what's inside|whats inside)\b/i },
    { key: "howTo", re: /^(how to use|how to apply|directions for use|directions|application|usage|how to)\b/i },
    { key: "perfectFor", re: /^(perfect for|ideal for|best for|great for|who it's for|who's it for|recommended for)\b/i },
    { key: "includes", re: /^(included in the bundle|what's included|whats included|the bundle includes|the ritual includes|the set includes|set includes|kit includes|this set includes|includes|included)\b/i },
    { key: "features", re: /^(key features|features|product details|specifications|tech specs)\b/i },
    { key: "size", re: /^(size|net weight|volume|capacity|net wt)\b/i }
  ];

  var GLUED_HEADERS = [
    "How to Use",
    "How to Apply",
    "Directions",
    "Key Ingredients",
    "Key Benefits",
    "What You'll Love",
    "Why You'll Love It",
    "Perfect For",
    "The Ritual Includes",
    "Included In The Bundle",
    "Net Weight"
  ];

  var ETHICS_BADGES = [
    { match: ["vegan"], label: "Vegan" },
    { match: ["cruelty-free", "cruelty free", "crueltyfree"], label: "Cruelty-Free" },
    { match: ["paraben-free", "paraben free"], label: "Paraben-Free" },
    { match: ["sls-free", "sls free", "sulfate-free", "sulfate free"], label: "Sulfate-Free" },
    { match: ["fragrance-free", "fragrance free"], label: "Fragrance-Free" },
    { match: ["organic"], label: "Organic" },
    { match: ["natural"], label: "Natural" },
    { match: ["made in canada", "canadian"], label: "Curated in Canada" }
  ];

  var THEME_TITLES = [
    { match: /hydrat|moistur|dewy|nourish|condition/i, title: "Deep hydration" },
    { match: /bright|glow|radian|luminos|dark spot|tone/i, title: "Visible glow" },
    { match: /calm|comfort|sensitive|irritat|redness|sooth/i, title: "Calm and soothe" },
    { match: /recover|massage|circulat|tension|relief|muscle|lymph/i, title: "Release and recover" },
    { match: /protect|shield|spf|uv|defen|antioxidant/i, title: "Daily protection" },
    { match: /smooth|texture|polish|exfoliat|refine/i, title: "Smooth and refine" },
    { match: /hair|scalp|shine|frizz/i, title: "Healthy hair" },
    { match: /sleep|stress|ground|relax|rest/i, title: "Rest and reset" }
  ];

  var CATEGORY_BENEFITS = {
    "face-care": ["Deep hydration", "Visible glow", "Barrier support", "Daily ritual ready"],
    "body-care": ["Softens skin", "Nourishing feel", "Spa-like ritual", "Daily body care"],
    "hair-care": ["Softness and shine", "Scalp support", "Healthy texture", "Easy routine fit"],
    "makeup": ["Buildable payoff", "Effortless wear", "Skin-friendly finish", "Everyday ready"],
    "beauty-tools": ["Releases tension", "Boosts circulation", "Sculpts and de-puffs", "Easy to reach for"],
    "massagers": ["Targeted relief", "Daily recovery", "Muscle support", "Easy to use"],
    "massage-chairs": ["Full-body recovery", "Deep relaxation", "Stress relief", "At-home reset"],
    "led-light-therapy": ["Clinically inspired", "Targeted treatment", "Recovery support", "Easy consistency"],
    "saunas": ["Deep recovery", "Sweat and reset", "Grounding ritual", "Wellness at home"],
    "cold-plunges": ["Cold recovery", "Sharper focus", "Built resilience", "Daily reset"]
  };

  var CATEGORY_HOWTO = {
    "face-care": [
      { title: "Prep", text: "Start with clean skin so the formula can absorb properly." },
      { title: "Apply", text: "Use a small amount and work it in evenly over the face and neck." },
      { title: "Finish", text: "Follow with the next step in your routine and stay consistent for best results." }
    ],
    "body-care": [
      { title: "Prep", text: "Use on clean or slightly damp skin for the smoothest application." },
      { title: "Massage in", text: "Work it in with slow, even pressure until it feels fully absorbed." },
      { title: "Repeat", text: "Use consistently as part of your daily or evening ritual." }
    ],
    "hair-care": [
      { title: "Apply", text: "Work through damp hair or scalp where it is needed most." },
      { title: "Let it work", text: "Give the formula time to do its job before styling or rinsing." },
      { title: "Keep it consistent", text: "Use regularly for the most visible payoff over time." }
    ],
    "massagers": [
      { title: "Target the area", text: "Place the device where you feel the most tension or fatigue." },
      { title: "Adjust the intensity", text: "Start low and increase to the level that feels effective but comfortable." },
      { title: "Move slowly", text: "Use slow, controlled passes and make it part of your recovery routine." }
    ],
    "massage-chairs": [
      { title: "Get comfortable", text: "Settle in and allow the chair to position around your body." },
      { title: "Choose your program", text: "Pick the intensity or massage style that matches how you feel today." },
      { title: "Unwind fully", text: "Stay through the full cycle so the session can do its best work." }
    ],
    "led-light-therapy": [
      { title: "Start clean", text: "Use on clean, dry skin so the light can reach the surface properly." },
      { title: "Run the session", text: "Stay with the device for the full recommended treatment window." },
      { title: "Follow with skincare", text: "Finish with the rest of your routine once the treatment is done." }
    ]
  };

  var SIZE_LIKE = /^\s*\d+(\.\d+)?\s*(g|mg|kg|ml|l|oz|fl\.?\s*oz|lb|ct|count|pcs?|pieces?|capsules?|tablets?|servings?|sheets?|masks?|wipes?|pads?)\b\.?\s*$/i;
  var BULLET_RE = /[•·▪‣◦●∙*]|✔|✓|✅|☑/;
  var GLUE_BEFORE = new RegExp("([a-z0-9.,)%'\"])" + "(" + GLUED_HEADERS.join("|") + ")\\b", "g");
  var GLUE_AFTER = new RegExp("(How to Use|How to Apply|Directions)([A-Z])", "g");
  var PRACTICAL_DETAIL_RE = /\b(bpa|lead[- ]free|plastic|toxins?|durable|glass|stainless|steel|silicone|ceramic|crystal|recharge|battery|cord|wireless|portable|travel|washable|hand wash|dishwasher|waterproof|splashproof|packaging|gift|included|full[- ]size|kit|set|bundle|capacity|size|dimensions?|materials?|made from|made of|vegan|cruelty[- ]free|made in canada|canadian|minutes?|sessions?)\b/i;
  var HELPER_COPY_RE = /\b(internal note|helper note|placeholder|todo|tbd)\b|will be added soon|best-for notes|buyers look for before checkout|the strongest reasons to buy|practical details that help you choose confidently/i;
  var INGREDIENT_TOKEN_RE = /\b(acid|acids|oil|oils|extract|extracts|vitamin|vitamins|collagen|charcoal|glycerin|aloe|niacinamide|retinol|peptide|peptides|ceramide|ceramides|clay|butter|powder|protein|gold|salt|mint|caffeine|hyaluronic|chaga|bergamot|cedarwood|lavender|chamomile|grapefruit|avocado|marula|shea|tamanu|willowherb|defensil|allantoin|cucumber|cellulose|nanogold|24kt|bamboo|tea tree|argan|jojoba|rosehip|squalane|zinc|magnesium|menthol|arnica|bakuchiol|urea|sulfur|spirulina|kale|spinach|glucosamine|cinnamon|calendula|rose|green tea|kaolin|hemp|eucalyptus|pine|castor|frankincense|camellia|coconut|beeswax|monoi|pumpkin|witch hazel|apple|acai|pycnogenol|panthenol|cica|rice bran|colloidal|prostaglandins|sunflower|tangerine)\b/i;
  var NON_INGREDIENT_TOKEN_RE = /\b(makeup|dirt|sunscreen|solution|warm water|water-activated|water activated|cloth|wipe|wipes|tool|device|kit|set|box|chair|slipper|bottle|lashes?|coverage|full-face|full face|fiber|fibers|smarterase|patented|disposable|results?|experience|comfort|friends?|intention|balance|renewal|resilience|radiance|stickiness|approach|securely|softens|helping|moisturized|seating|retreat|performers)\b/i;
  var INGREDIENT_PREFIX_RE = /^(with|powered by|featuring|includes?|high(?:\s*-\s*|\s+)quality|silky|real|nourishing|calming botanicals(?: like)?|antioxidant(?:\s*-\s*|\s+)rich|mineral(?:\s*-\s*|\s+)rich|plant(?:\s*-\s*|\s+)based(?: approach)?|enriched|clinically studied|organic|just|only|deep|daily|advanced|oil(?:\s*-\s*|\s+)free|non(?:\s*-\s*|\s+)toxic|moisturizing|hydrating)\s+/i;
  var DESCRIPTION_INGREDIENT_ALLOW_RE = /\b(serum|cleanser|face wash|mask|cream|lotion|oil|scrub|gel|balm|moisturizer|conditioner|shampoo|perfume|eyeliner|mascara|patch|repellent|spray|butter|treatment|under eye|lip jelly|lip mask|eye mask|face mask|sheet mask|foot cream|body lotion|body scrub|hair mask|hairbath)\b/i;
  var DESCRIPTION_INGREDIENT_BLOCK_RE = /\b(slipper|bracelet|cuff|bottle|chair|sauna|plunge|massager|roller|gua sha|glasses|towel|makeup eraser|microcurrent|radio frequency|crystal infusion|foot massager|beauty tool|therapy device|cold tub|chiller|cleansing kit)\b/i;
  var DESCRIPTION_INGREDIENT_BLOCK_COLLECTIONS = [
    "beauty-tools",
    "massagers",
    "massage-chairs",
    "led-light-therapy",
    "saunas",
    "cold-plunges",
    "wellness-decor",
    "desk-wellness",
    "office-light-therapy",
    "office-installs",
    "home-spa-outfitting",
    "for-the-office"
  ];
  var DESCRIPTION_INGREDIENT_ALLOW_COLLECTIONS = [
    "face-care",
    "body-care",
    "hair-care",
    "makeup",
    "blemish-control",
    "cleanser",
    "moisturizer",
    "face-masks",
    "face-oil",
    "body-lotion",
    "body-exfoliation",
    "hair-oil",
    "shampoo-conditioner",
    "skin-care-collection"
  ];

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function normalizeWhitespace(text) {
    return String(text || "")
      .replace(/[\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000]/g, " ")
      .replace(/[\u2018\u2019]/g, "'")
      .replace(/[\u201C\u201D]/g, '"')
      .replace(/\r\n/g, "\n")
      .replace(/\r/g, "\n")
      .replace(/\t/g, " ")
      .replace(/\s+\n/g, "\n")
      .replace(/\n\s+/g, "\n")
      .replace(/[ ]{2,}/g, " ")
      .trim();
  }

  function isHelperCopy(text) {
    var clean = normalizeWhitespace(text);
    if (!clean) return false;
    return HELPER_COPY_RE.test(clean);
  }

  function htmlToText(html) {
    var wrapper = document.createElement("div");
    wrapper.innerHTML = String(html || "").replace(/<br\s*\/?>/gi, "\n");
    var blocks = wrapper.querySelectorAll("p, li, h1, h2, h3, h4, h5, h6");
    if (blocks.length) {
      return normalizeWhitespace(
        Array.prototype.map.call(blocks, function (node) {
          return normalizeWhitespace(node.textContent || "");
        })
          .filter(Boolean)
          .join("\n")
      );
    }
    return normalizeWhitespace(wrapper.textContent || "");
  }

  function splitSentences(text) {
    return normalizeWhitespace(text)
      .split(/(?<=[.!?])\s+(?=[A-Z0-9])/)
      .map(function (part) {
        return part.trim();
      })
      .filter(function (part) {
        return part.length > 2;
      });
  }

  function truncateWords(text, maxWords) {
    var words = normalizeWhitespace(text).split(/\s+/);
    if (words.length <= maxWords) return words.join(" ");
    return words.slice(0, maxWords).join(" ") + "…";
  }

  function shortLabel(text, maxWords) {
    var label = normalizeWhitespace(text);
    var dashParts = label.split(/\s+[–\-—]\s+/);
    if (dashParts.length > 1 && dashParts[0].length <= 28) {
      label = dashParts[0];
    }
    label = label.split(/\s+/).slice(0, maxWords || 4).join(" ").replace(/[.,;:!]+$/, "");
    label = label.replace(/\b(to|for|with|of|and|or)$/i, "").trim();
    if (label.length > 34) {
      label = label.slice(0, 32).trimEnd() + "…";
    }
    return label.charAt(0).toUpperCase() + label.slice(1);
  }

  function titleForBenefit(text) {
    for (var i = 0; i < THEME_TITLES.length; i += 1) {
      if (THEME_TITLES[i].match.test(text)) {
        return THEME_TITLES[i].title;
      }
    }
    return "Made to perform";
  }

  function firstCollectionHandle(product) {
    return Array.isArray(product.collections) && product.collections.length ? product.collections[0].handle : "";
  }

  function firstCollectionTitle(product) {
    return Array.isArray(product.collections) && product.collections.length ? product.collections[0].title : "";
  }

  function meaningfulVariantTitle(value) {
    var clean = normalizeWhitespace(value);
    if (!clean || /^default title$/i.test(clean)) return "";
    return clean;
  }

  function collectionHandles(product) {
    return Array.isArray(product.collections)
      ? product.collections.map(function (collection) {
          return String(collection.handle || "").toLowerCase();
        })
      : [];
  }

  function isRouteineProduct(product) {
    var handle = String(product.handle || "").toLowerCase();
    var vendor = String(product.vendor || "").toLowerCase();
    var collectionHandles = Array.isArray(product.collections)
      ? product.collections.map(function (collection) {
          return String(collection.handle || "").toLowerCase();
        })
      : [];

    if (collectionHandles.indexOf("the-routeine-box") !== -1) return true;
    if (collectionHandles.indexOf("the-routeine-box-singles") !== -1) return true;
    if (vendor.indexOf("wellness route") !== -1 && /routeine|first-melt|morning-shield|night-renew|dream-cream|deep-reset/.test(handle)) return true;
    return false;
  }

  function uniqueStrings(items) {
    var seen = new Set();
    var output = [];
    items.forEach(function (item) {
      var value = normalizeWhitespace(item);
      var key = value.toLowerCase();
      if (!value || seen.has(key)) return;
      seen.add(key);
      output.push(value);
    });
    return output;
  }

  function toIngredient(text) {
    var match = normalizeWhitespace(text).match(/^(.*?)\s*[–\-—:]\s+(.+)$/);
    if (match && match[1].length <= 60) {
      return { name: match[1].trim(), desc: match[2].trim() };
    }
    return { name: normalizeWhitespace(text), desc: "" };
  }

  function parseProductContent(descriptionHtml) {
    var result = {
      lead: [],
      benefits: [],
      ingredients: [],
      howTo: [],
      perfectFor: [],
      includes: [],
      features: [],
      size: ""
    };

    var text = htmlToText(descriptionHtml)
      .replace(GLUE_BEFORE, "$1\n$2")
      .replace(GLUE_AFTER, "$1\n$2")
      .replace(/\s*([•·▪‣◦●∙]|✔|✓|✅|☑)\s*/g, "\n$1 ");
    var lines = text
      .split("\n")
      .map(function (line) {
        return normalizeWhitespace(line);
      })
      .filter(Boolean);
    var section = "lead";

    function pushContent(key, value) {
      var clean = normalizeWhitespace(value);
      if (!clean) return;
      if (isHelperCopy(clean)) return;
      if (key === "benefits") result.benefits.push(clean);
      if (key === "ingredients") result.ingredients.push(toIngredient(clean));
      if (key === "howTo") result.howTo.push(clean);
      if (key === "perfectFor") result.perfectFor.push(clean);
      if (key === "includes") result.includes.push(clean);
      if (key === "features") result.features.push(clean);
      if (key === "size" && !result.size) result.size = clean;
      if (key === "lead") result.lead.push(clean);
    }

    lines.forEach(function (line) {
      if (!line) return;
      if (BULLET_RE.test(line.charAt(0))) {
        var bulletText = line.replace(/^[•·▪‣◦●∙*✔✓✅☑]\s*/, "").trim();
        var target = section === "lead" || section === "size" ? "features" : section;
        pushContent(target, bulletText);
        return;
      }

      var header = HEADER_PATTERNS.find(function (entry) {
        return entry.re.test(line);
      });

      if (header) {
        section = header.key;
        var remainder = line.replace(header.re, "").replace(/^[\s:–\-—]+/, "").trim();
        if (remainder) pushContent(section, remainder);
        return;
      }

      pushContent(section === "lead" ? "lead" : section, line);
    });

    if (!result.benefits.length && result.features.length) {
      result.benefits = result.features.slice();
    }

    return result;
  }

  function getFallbackBenefits(product) {
    var collectionHandle = firstCollectionHandle(product);
    return CATEGORY_BENEFITS[collectionHandle] || [
      "Thoughtfully curated",
      "Easy to work into daily life",
      "Chosen for real routines",
      "High-standard product"
    ];
  }

  function cleanLeadParagraphs(leadItems) {
    return uniqueStrings(leadItems).filter(function (entry, index) {
      if (!entry) return false;
      if (isHelperCopy(entry)) return false;
      var wordCount = entry.split(/\s+/).length;
      if (index === 0 && wordCount <= 5 && !/[.!?]$/.test(entry)) {
        return false;
      }
      return true;
    });
  }

  function buildHeroSummary(parsed, product) {
    var leadItems = cleanLeadParagraphs(parsed.lead);
    var sentences = splitSentences(leadItems.join(" "));
    var selected = [];
    var totalLength = 0;

    for (var i = 0; i < sentences.length; i += 1) {
      if (totalLength + sentences[i].length > 190 && selected.length) break;
      selected.push(sentences[i]);
      totalLength += sentences[i].length + 1;
      if (totalLength > 145) break;
    }

    if (selected.length) return selected.join(" ");
    if (leadItems.length) return truncateWords(leadItems[0], 28);
    return truncateWords(product.title + " is a curated pick from The Wellness Route, chosen to feel effective, beautiful, and easy to use.", 28);
  }

  function buildBenefits(parsed, product) {
    var source = parsed.benefits.length ? parsed.benefits : parsed.features;
    var benefits = uniqueStrings(
      source.map(function (entry) {
        return shortLabel(entry, 4);
      })
    ).slice(0, 4);
    if (benefits.length >= 2) {
      while (benefits.length < 4) {
        benefits.push(getFallbackBenefits(product)[benefits.length]);
      }
      return benefits.slice(0, 4);
    }
    return getFallbackBenefits(product).slice(0, 4);
  }

  function buildHighlights(parsed, product) {
    var source = parsed.benefits.length ? parsed.benefits : parsed.lead.concat(parsed.features);
    var seen = new Set();
    var highlights = [];

    source.forEach(function (entry) {
      var title = titleForBenefit(entry);
      if (!entry || entry.length < 12 || seen.has(title)) return;
      seen.add(title);
      highlights.push({
        title: title,
        text: entry.charAt(0).toUpperCase() + entry.slice(1)
      });
    });

    if (!highlights.length) {
      var fallbacks = getFallbackBenefits(product);
      fallbacks.forEach(function (label) {
        if (highlights.length >= 3) return;
        highlights.push({
          title: label,
          text: "A clearer reason this product earns its place in the routine."
        });
      });
    }

    return highlights.slice(0, 3);
  }

  function buildWhatItIs(parsed, product) {
    var leadText = cleanLeadParagraphs(parsed.lead).join(" ");
    var sentences = splitSentences(leadText);
    if (sentences.length) return sentences.slice(0, Math.min(2, sentences.length));
    return [product.title + " is a curated product chosen to feel credible, useful, and easy to return to."];
  }

  function buildWhatItDoes(parsed, product) {
    var items = uniqueStrings(parsed.benefits.concat(parsed.features)).slice(0, 4);
    if (items.length) return items;
    return [
      product.title + " is meant to support a routine that feels more effective and more consistent.",
      "It earns its place by solving a real need without overcomplicating the ritual."
    ];
  }

  function buildLeadParagraphs(parsed, product) {
    var leadItems = cleanLeadParagraphs(parsed.lead);
    if (leadItems.length) return leadItems;
    return [product.title + " is part of the Wellness Route edit: thoughtful products chosen for real life, real routines, and results you can actually stick with."];
  }

  function makeStepTitle(stepText, index) {
    var clean = normalizeWhitespace(stepText).replace(/[.]+$/, "");
    var label = clean.split(/[:,-]/)[0];
    label = shortLabel(label, 3);
    if (label.length < 4) return "Step " + String(index + 1).padStart(2, "0");
    return label;
  }

  function formatSpecItem(text) {
    var clean = normalizeWhitespace(text).replace(/^[•·▪‣◦●∙*✔✓✅☑]\s*/, "").trim();
    if (!clean) return "";
    if (SIZE_LIKE.test(clean)) return "Size: " + clean;
    if (/^[a-z]/.test(clean)) return clean.charAt(0).toUpperCase() + clean.slice(1);
    return clean;
  }

  function isLikelyIngredientToken(text) {
    var clean = normalizeWhitespace(text)
      .replace(/[®™]/g, "")
      .replace(/^[•·▪‣◦●∙*✔✓✅☑]\s*/g, "")
      .replace(/[.;:]+$/g, "");
    var wordCount = clean ? clean.split(/\s+/).length : 0;

    if (!clean) return false;
    if (/^(a|an|the)\b/i.test(clean)) return false;
    if (NON_INGREDIENT_TOKEN_RE.test(clean)) return false;
    if (/\b(remove|removing|hydrate|hydrating|brighten|brightening|defend|defending|clean|cleansing|soothe|soothing|exfoliate|exfoliating|support|supports|promote|promotes|using|designed|erase|erasing|lift|lifts)\b/i.test(clean)) {
      return false;
    }
    if (wordCount > 4 && !/(essential oils?|seed oil|leaf extract|root extract|fruit extract)/i.test(clean)) {
      return false;
    }
    return INGREDIENT_TOKEN_RE.test(clean);
  }

  function cleanIngredientCandidate(text) {
    return normalizeWhitespace(text)
      .replace(/[®™]/g, "")
      .replace(/^[•·▪‣◦●∙*✔✓✅☑]\s*/g, "")
      .replace(/[.;:]+$/g, "")
      .replace(INGREDIENT_PREFIX_RE, "")
      .replace(/^like\s+/i, "")
      .trim();
  }

  function isProductTitleEcho(candidate, product) {
    var cleanCandidate = normalizeWhitespace(candidate)
      .replace(/[®™]/g, "")
      .replace(/[^a-z0-9]+/gi, " ")
      .toLowerCase();
    var cleanTitle = normalizeWhitespace(product && product.title)
      .replace(/[®™]/g, "")
      .replace(/[^a-z0-9]+/gi, " ")
      .toLowerCase();

    if (!cleanCandidate || !cleanTitle) return false;
    if (cleanCandidate.split(/\s+/).length < 3) return false;
    if (!/\b(mask|cream|serum|lotion|oil|treatment|dots|jelly)\b/i.test(cleanCandidate)) return false;

    return cleanTitle.indexOf(cleanCandidate) !== -1;
  }

  function canUseDescriptionIngredientFallback(product) {
    var handles = collectionHandles(product);
    var haystack = normalizeWhitespace([
      product.title,
      product.type,
      product.vendor,
      handles.join(" ")
    ].join(" ")).toLowerCase();

    if (DESCRIPTION_INGREDIENT_BLOCK_RE.test(haystack)) return false;
    if (handles.some(function (handle) { return DESCRIPTION_INGREDIENT_BLOCK_COLLECTIONS.indexOf(handle) !== -1; })) {
      return false;
    }
    if (DESCRIPTION_INGREDIENT_ALLOW_RE.test(haystack)) return true;
    if (handles.some(function (handle) { return DESCRIPTION_INGREDIENT_ALLOW_COLLECTIONS.indexOf(handle) !== -1; })) {
      return true;
    }

    return false;
  }

  function isPracticalDetail(text) {
    var clean = normalizeWhitespace(text);
    if (!clean) return false;
    if (SIZE_LIKE.test(clean)) return true;
    if (PRACTICAL_DETAIL_RE.test(clean)) return true;
    if (/^[A-Z0-9][A-Za-z0-9 '&()/+-]{1,32}\s*[:–\-—]\s+.+$/.test(clean)) return true;
    return false;
  }

  function extractPracticalSentences(text) {
    return splitSentences(text)
      .filter(function (sentence) {
        return isPracticalDetail(sentence);
      })
      .map(function (sentence) {
        return formatSpecItem(truncateWords(sentence, 18));
      });
  }

  function toBestForNote(text) {
    var clean = normalizeWhitespace(text).replace(/[.]+$/, "");
    if (!clean) return "";
    if (/^best for\b/i.test(clean)) return clean;
    return "Best for " + clean.replace(/^[A-Z]/, function (match) {
      return match.toLowerCase();
    });
  }

  function buildGoodToKnowItems(parsed, product, options) {
    options = options || {};

    var items = [];
    var featureItems = uniqueStrings(parsed.features);
    var includedItems = uniqueStrings(parsed.includes);
    var bestForItems = uniqueStrings(parsed.perfectFor);

    if (parsed.size) {
      items.push(formatSpecItem(parsed.size));
    }

    featureItems.forEach(function (item) {
      if (!isPracticalDetail(item)) return;
      items.push(formatSpecItem(item));
    });

    if (options.includeIncludedItems) {
      includedItems.forEach(function (item) {
        var clean = formatSpecItem(item);
        if (!clean) return;
        if (!/^includes?\b/i.test(clean) && !/^what'?s included\b/i.test(clean)) {
          clean = "Includes " + clean.replace(/^[A-Z]/, function (match) {
            return match.toLowerCase();
          });
        }
        items.push(clean);
      });
    }

    if (items.length < 3) {
      extractPracticalSentences(htmlToText(product.description_html || "")).forEach(function (sentence) {
        items.push(sentence);
      });
    }

    if (items.length < 3) {
      bestForItems.slice(0, 2).forEach(function (item) {
        items.push(toBestForNote(item));
      });
    }

    if (items.length < 2 && isRouteineProduct(product)) {
      buildRouteineGoodToKnowFallback(parsed, product).forEach(function (item) {
        items.push(item);
      });
    }

    return uniqueStrings(items)
      .filter(function (item) {
        return item && item.length >= 6;
      })
      .slice(0, 4);
  }

  function buildRouteineGoodToKnowFallback(parsed, product) {
    var items = ["Created by Diana Jenne"];
    var text = normalizeWhitespace([
      htmlToText(product.description_html || ""),
      parsed.howTo.join(" "),
      parsed.features.join(" "),
      parsed.benefits.join(" ")
    ].join(" "));

    if (/morning and night|morning & night|day and night/i.test(text)) {
      items.push("Made for morning and night use");
    } else if (/morning/i.test(text)) {
      items.push("Made for morning use");
    } else if (/night|evening|bed/i.test(text)) {
      items.push("Made for evening use");
    } else {
      items.push("Designed to support consistent daily use");
    }

    if (/protect|defend|antioxidant|environmental stress/i.test(text)) {
      items.push("Supports daily antioxidant defense");
    } else if (/hydrat|moistur/i.test(text)) {
      items.push("Hydration-first support for daily skin");
    } else if (/calm|soothe|comfort/i.test(text)) {
      items.push("Built to calm and support the skin barrier");
    }

    return uniqueStrings(items).slice(0, 3);
  }

  function buildWhyWePickedIt(product) {
    if (isRouteineProduct(product)) {
      return [
        "This made the cut because it supports a routine that feels simpler to keep and more rewarding to come back to.",
        "The goal was never more steps for the sake of it. The goal was something effective enough to notice and realistic enough to repeat."
      ];
    }

    return [
      "Diana curated this because it solves a real need in the ritual and feels credible enough to keep reaching for.",
      "If it is here, it earned its place through usefulness, quality, and how naturally it fits into real daily life."
    ];
  }

  function buildFounderTitle(product) {
    return isRouteineProduct(product) ? "Why Diana made it" : "Why Diana chose it";
  }

  function buildFounderNote(product) {
    if (isRouteineProduct(product)) {
      return "Created by Diana Jenne to make effective skincare feel simpler, more elevated, and easier to stick with.";
    }

    return "Personally selected by Diana for quality, ritual fit, and the kind of results worth coming back to.";
  }

  function buildFounderStory(product) {
    if (isRouteineProduct(product)) {
      return [
        "ROUTEine was built by Diana after seeing how many skincare routines felt crowded, confusing, or too high-maintenance to stay consistent with.",
        "Each formula is meant to feel elevated but realistic: beautiful enough to enjoy, effective enough to notice, and simple enough to become part of daily life."
      ];
    }

    return [
      "Diana curates the shop product by product, looking for pieces that solve a real need and fit naturally into a thoughtful ritual.",
      "This one earned its place because it feels credible, useful, and easy to keep reaching for long after the first try."
    ];
  }

  function buildHowTo(parsed, product, data) {
    var steps = [];
    parsed.howTo.forEach(function (block) {
      splitSentences(block).forEach(function (sentence) {
        if (!SIZE_LIKE.test(sentence)) steps.push(sentence);
      });
    });

    if (!steps.length && data.metafields && data.metafields.how_to_use) {
      steps = splitSentences(htmlToText(data.metafields.how_to_use));
    }

    if (!steps.length) {
      var fallbackSteps = CATEGORY_HOWTO[firstCollectionHandle(product)] || [
        { title: "Start simple", text: "Add it at the point in your routine where you are most likely to stay consistent." },
        { title: "Use it regularly", text: "The best results come from repetition, not one-off use." },
        { title: "Make it part of the ritual", text: "Keep it easy to reach so it naturally becomes part of your rhythm." }
      ];
      return fallbackSteps.slice(0, 3);
    }

    return steps.slice(0, 3).map(function (step, index) {
      return {
        title: makeStepTitle(step, index),
        text: step
      };
    });
  }

  function inferProductFormat(product) {
    var haystack = uniqueStrings([
      product.title,
      product.type,
      product.variant_title
    ].concat(product.tags || [])).join(" ").toLowerCase();

    if (/balm cleanser|cleansing balm/.test(haystack)) return "Balm cleanser";
    if (/cleanser|face wash|wash\b/.test(haystack)) return "Cleanser";
    if (/moisturizer|day cream|night cream|dream cream|cream\b/.test(haystack)) return "Cream";
    if (/serum/.test(haystack)) return "Serum";
    if (/mask/.test(haystack)) return "Mask";
    if (/bottle/.test(haystack)) return "Bottle";
    if (/gua sha|roller|tool|massager|device/.test(haystack)) return "Wellness tool";
    if (/led|light therapy/.test(haystack)) return "Light therapy device";
    return "";
  }

  function buildSpecs(parsed, product, goodToKnowItems) {
    var cards = [];
    var includedItems = uniqueStrings(parsed.includes).slice(0, 5);
    var perfectFor = uniqueStrings(parsed.perfectFor).slice(0, 5);
    var practicalItems = uniqueStrings(goodToKnowItems || []);
    var benefitDetails = uniqueStrings(parsed.features.concat(parsed.benefits))
      .map(function (item) {
        return formatSpecItem(truncateWords(item, 16));
      })
      .slice(0, 4);
    var details = [];
    var formatDetail = inferProductFormat(product);
    var variantTitle = meaningfulVariantTitle(product.variant_title);

    if (formatDetail) details.push("Format: " + formatDetail);
    if (parsed.size) details.push("Size: " + parsed.size);
    if (!parsed.size && variantTitle) {
      if (SIZE_LIKE.test(variantTitle)) {
        details.push("Size: " + variantTitle);
      } else {
        details.push("Option: " + variantTitle);
      }
    }
    if (product.type) details.push("Type: " + product.type);
    if (!details.length && product.vendor) details.push("Brand: " + product.vendor);

    if (practicalItems.length) {
      cards.push({ title: "Good to know", items: practicalItems });
    } else if (benefitDetails.length) {
      cards.push({ title: "Worth knowing", items: benefitDetails });
    }

    if (perfectFor.length) {
      cards.push({ title: "Best for", items: perfectFor });
    }

    if (includedItems.length) {
      cards.push({ title: "What's included", items: includedItems });
    }

    if (details.length || product.tags.length) {
      cards.push({ title: "Quick details", items: details, chips: uniqueStrings(product.tags).slice(0, 8) });
    }

    if (!cards.length) {
      if (formatDetail) details.push("Format: " + formatDetail);
      if (product.type) details.push("Category: " + product.type);
      if (firstCollectionTitle(product)) details.push("Collection: " + firstCollectionTitle(product));
      if (!details.length && product.vendor) details.push("Brand: " + product.vendor);

      cards.push({
        title: "Quick details",
        items: uniqueStrings(details).slice(0, 4)
      });
    }

    return cards.slice(0, 4);
  }

  function splitIngredientSource(text) {
    return normalizeWhitespace(text)
      .replace(/\bessential oils?\b/i, "essential oils")
      .replace(/\s+and\s+/gi, ", ")
      .split(",")
      .map(function (entry) {
        return cleanIngredientCandidate(entry);
      })
      .filter(function (entry) {
        return entry &&
          entry.length >= 3 &&
          entry.length <= 48 &&
          !/\b(brighten|hydrate|defend|supports?|promotes?|protects?|nourishes?|ritual|skin|complexion|stress|mood|focus)\b/i.test(entry) &&
          isLikelyIngredientToken(entry);
      });
  }

  function extractIngredientsFromDescription(product) {
    if (!canUseDescriptionIngredientFallback(product)) return [];

    var text = htmlToText(product.description_html || "");
    var matches = [];
    [
      /\bwith\s+([^.;]+?)(?:\s+to\b|,?\s+that\b|,?\s+which\b|[.;])/i,
      /\bpowered by\s+([^.;]+?)(?:\s+to\b|,?\s+that\b|,?\s+which\b|[.;])/i,
      /\bfeaturing\s+([^.;]+?)(?:\s+to\b|,?\s+that\b|,?\s+which\b|[.;])/i,
      /\bhero ingredients?\s+(?:include|are)\s+([^.;]+?)(?:[.;]|$)/i
    ].forEach(function (pattern) {
      var match = text.match(pattern);
      if (match && match[1]) {
        matches = matches.concat(splitIngredientSource(match[1]));
      }
    });

    return uniqueStrings(matches)
      .filter(function (entry) {
        return !isProductTitleEcho(entry, product);
      })
      .slice(0, 8);
  }

  function buildIngredients(parsed, data, product) {
    var ingredients = parsed.ingredients.slice();
    if (!ingredients.length && data.metafields && data.metafields.ingredients) {
      var ingredientText = htmlToText(data.metafields.ingredients);
      var rawEntries = ingredientText
        .split("\n")
        .map(function (entry) {
          return normalizeWhitespace(entry);
        })
        .filter(Boolean);

      if (rawEntries.length === 1 && ingredientText.indexOf(",") !== -1) {
        rawEntries = ingredientText
          .split(/\s*,\s*/)
          .map(function (entry) {
            return normalizeWhitespace(entry);
          })
          .filter(Boolean);
      }

      ingredients = rawEntries.map(toIngredient);
    }

    if (!ingredients.length) {
      ingredients = extractIngredientsFromDescription(product).map(function (name) {
        return { name: name, desc: "" };
      });
    }

    return ingredients.slice(0, 8);
  }

  function buildEthics(product) {
    var haystack = uniqueStrings([product.vendor, product.type].concat(product.tags).concat([htmlToText(product.description_html)])).join(" ").toLowerCase();
    var badges = [];
    ETHICS_BADGES.forEach(function (badge) {
      if (badge.match.some(function (token) { return haystack.indexOf(token) !== -1; })) {
        badges.push(badge.label);
      }
    });
    if (product.featured) badges.push("Featured pick");
    if (product.dianas_favourite) badges.push("Diana's favourite");
    return uniqueStrings(badges).slice(0, 5);
  }

  function buildHeroGlance(parsed, product) {
    var items = buildGoodToKnowItems(parsed, product, { includeIncludedItems: true }).slice(0, 3);

    if (!items.length && isRouteineProduct(product)) {
      items = [
        "Created by Diana Jenne",
        "Made to support consistent daily use",
        "Designed to feel effective without overcomplicating your routine"
      ];
    }

    return items;
  }

  function inferUsageWindow(product, parsed, howTo) {
    var haystack = normalizeWhitespace([htmlToText(product.description_html || ""), parsed.howTo.join(" "), (howTo || []).map(function (step) { return step.text; }).join(" ")].join(" "));

    if (/morning and night|morning & night|day and night/i.test(haystack)) return "Morning and night";
    if (/morning/i.test(haystack) && /night|evening|bed/i.test(haystack)) return "Morning and night";
    if (/morning/i.test(haystack)) return "Morning routine";
    if (/night|evening|bed/i.test(haystack)) return "Evening routine";
    if (/daily|every day/i.test(haystack)) return "Daily use";
    if (/anytime/i.test(haystack)) return "Anytime you need it";
    return "Easy to work into your routine";
  }

  function buildProductFacts(parsed, product, howTo, ingredients, benefitItems) {
    var facts = [];
    var formatDetail = inferProductFormat(product);
    var categoryDetail = firstCollectionTitle(product) || product.type || "Wellness essential";
    var bestForItems = uniqueStrings(parsed.perfectFor).slice(0, 2);
    var benefitSummary = uniqueStrings((benefitItems || []).slice(0, 2)).join(", ");
    var ingredientSummary = uniqueStrings((ingredients || []).map(function (item) { return item.name; })).slice(0, 3).join(", ");

    if (formatDetail || categoryDetail) {
      facts.push({
        label: "Product type",
        value: uniqueStrings([formatDetail, categoryDetail]).join(" · ")
      });
    }

    if (bestForItems.length) {
      facts.push({
        label: "Best for",
        value: bestForItems.join(", ")
      });
    } else if (benefitSummary) {
      facts.push({
        label: "Targets",
        value: benefitSummary
      });
    }

    facts.push({
      label: "Use it when",
      value: inferUsageWindow(product, parsed, howTo)
    });

    if (ingredientSummary) {
      facts.push({
        label: "Key ingredients",
        value: ingredientSummary
      });
    }

    if (parsed.size) {
      facts.push({
        label: "Size",
        value: parsed.size
      });
    } else if (meaningfulVariantTitle(product.variant_title)) {
      facts.push({
        label: "Option",
        value: meaningfulVariantTitle(product.variant_title)
      });
    }

    return facts.slice(0, 4);
  }

  function buildIngredientsPanel(parsed, product, data, ingredients) {
    if (data.metafields && data.metafields.ingredients) {
      return {
        label: "Full ingredient list",
        paragraphs: [htmlToText(data.metafields.ingredients)]
      };
    }

    var leadParagraphs = cleanLeadParagraphs(parsed.lead);
    var ingredientNames = uniqueStrings((ingredients || []).map(function (item) { return item.name; }));

    if (ingredientNames.length) {
      return {
        label: "Formula notes",
        paragraphs: uniqueStrings([
          leadParagraphs[0] || "",
          "Key ingredients include " + ingredientNames.join(", ") + "."
        ]).filter(Boolean).slice(0, 2)
      };
    }

    return {
      label: "Formula notes",
      paragraphs: leadParagraphs.slice(0, 2)
    };
  }

  function renderParagraphs(target, paragraphs) {
    if (!target) return;
    target.innerHTML = paragraphs
      .map(function (paragraph) {
        return "<p>" + escapeHtml(paragraph) + "</p>";
      })
      .join("");
  }

  function toggleAccordionItem(target, hasContent) {
    if (!target) return;
    var accordionItem = target.closest("[data-accordion-item]");
    if (!(accordionItem instanceof HTMLElement)) return;
    accordionItem.hidden = !hasContent;
  }

  function renderList(target, items, className) {
    if (!target) return;
    target.innerHTML = "<ul" + (className ? ' class="' + className + '"' : "") + ">" +
      items
        .map(function (item) {
          return "<li>" + escapeHtml(item) + "</li>";
        })
        .join("") +
      "</ul>";
  }

  function renderBenefits(target, items) {
    if (!target) return;
    target.innerHTML = items
      .map(function (item) {
        return '<div class="product-main__benefit">' + escapeHtml(item) + "</div>";
      })
      .join("");
  }

  function renderEthics(target, items) {
    if (!target) return;
    if (!items.length) {
      target.hidden = true;
      return;
    }
    target.hidden = false;
    target.innerHTML = items
      .map(function (item) {
        return '<span class="tag">' + escapeHtml(item) + "</span>";
      })
      .join("");
  }

  function renderGlance(target, items) {
    if (!target) return;
    if (!items.length) {
      target.hidden = true;
      return;
    }

    target.hidden = false;
    target.innerHTML =
      '<p class="product-main__glance-label">At a glance</p>' +
      '<ul class="product-main__glance-list">' +
      items
        .map(function (item) {
          return "<li>" + escapeHtml(item) + "</li>";
        })
        .join("") +
      "</ul>";
  }

  function renderHighlights(target, items) {
    if (!target) return;
    target.innerHTML = items
      .map(function (item, index) {
        return (
          '<div class="value-card">' +
            '<div class="value-card__body">' +
              '<div class="value-card__icon">' + escapeHtml(String(index + 1).padStart(2, "0")) + "</div>" +
              "<h3>" + escapeHtml(item.title) + "</h3>" +
              "<p>" + escapeHtml(item.text) + "</p>" +
            "</div>" +
          "</div>"
        );
      })
      .join("");
  }

  function renderHowTo(target, items) {
    if (!target) return;
    target.innerHTML = items
      .map(function (item, index) {
        return (
          '<article class="product-howto-card">' +
            '<div class="product-howto-card__count">' + escapeHtml(String(index + 1).padStart(2, "0")) + "</div>" +
            "<h3>" + escapeHtml(item.title) + "</h3>" +
            "<p>" + escapeHtml(item.text) + "</p>" +
          "</article>"
        );
      })
      .join("");
  }

  function renderSpecs(target, cards) {
    if (!target) return;
    target.innerHTML = cards
      .map(function (card) {
        var itemsHtml = card.items && card.items.length
          ? "<ul>" + card.items.map(function (item) { return "<li>" + escapeHtml(item) + "</li>"; }).join("") + "</ul>"
          : "";
        var chipsHtml = card.chips && card.chips.length
          ? '<div class="product-chip-list">' + card.chips.map(function (chip) { return '<span class="tag">' + escapeHtml(chip) + "</span>"; }).join("") + "</div>"
          : "";
        return (
          '<article class="info-panel product-spec-card">' +
            '<p class="eyebrow">' + escapeHtml(card.title) + "</p>" +
            itemsHtml +
            chipsHtml +
          "</article>"
        );
      })
      .join("");
  }

  function renderGoodToKnow(target, items) {
    if (!target) return;
    if (!items.length) {
      target.innerHTML = "";
      toggleAccordionItem(target, false);
      return;
    }
    toggleAccordionItem(target, true);
    target.innerHTML = "<ul>" +
      items
        .map(function (item) {
          return "<li>" + escapeHtml(item) + "</li>";
        })
        .join("") +
      "</ul>";
  }

  function renderAccordionParagraphs(target, paragraphs) {
    if (!target) return;
    if (!paragraphs.length) {
      target.innerHTML = "";
      toggleAccordionItem(target, false);
      return;
    }
    toggleAccordionItem(target, true);
    target.innerHTML = paragraphs
      .map(function (paragraph) {
        return "<p>" + escapeHtml(paragraph) + "</p>";
      })
      .join("");
  }

  function renderIngredients(target, ingredients) {
    if (!target) return;
    target.innerHTML = ingredients
      .map(function (ingredient) {
        return (
          '<article class="info-panel product-ingredients-card">' +
            "<h3>" + escapeHtml(ingredient.name) + "</h3>" +
            (ingredient.desc ? "<p>" + escapeHtml(ingredient.desc) + "</p>" : "") +
          "</article>"
        );
      })
      .join("");
  }

  function renderProductFacts(target, facts) {
    if (!target) return;
    target.innerHTML = facts
      .map(function (fact) {
        return (
          '<article class="product-fact-card">' +
            '<p class="product-fact-card__label">' + escapeHtml(fact.label) + "</p>" +
            '<p class="product-fact-card__value">' + escapeHtml(fact.value) + "</p>" +
          "</article>"
        );
      })
      .join("");
  }

  function renderIngredientsPanel(target, payload, labelTarget) {
    if (!target || !payload || !payload.paragraphs || !payload.paragraphs.length) return;
    if (labelTarget && payload.label) {
      labelTarget.textContent = payload.label;
    }
    target.innerHTML = payload.paragraphs
      .map(function (paragraph) {
        return "<p>" + escapeHtml(paragraph) + "</p>";
      })
      .join("");
  }

  function buildCheckoutTrustMarkup() {
    return [
      '<div class="product-main__checkout-trust" aria-label="Shopping reassurance">',
        '<article class="product-main__checkout-trust-item">',
          '<span class="product-main__checkout-trust-icon" aria-hidden="true">',
            '<svg viewBox="0 0 24 24" fill="none">',
              '<path d="M12 4.5c1.63 1.93 3.75 3.31 6.375 4.125v3.75c0 3.913-2.289 6.91-6.375 8.625-4.086-1.715-6.375-4.712-6.375-8.625v-3.75C8.25 7.81 10.37 6.43 12 4.5Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/>',
              '<path d="M9.75 12.25 11.1 13.6l3.15-3.2" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>',
            '</svg>',
          "</span>",
          "<div>",
            "<strong>Secure checkout</strong>",
            "<span>Encrypted checkout keeps your order secure, with available payment methods shown on the next step.</span>",
          "</div>",
        "</article>",
        '<article class="product-main__checkout-trust-item">',
          '<span class="product-main__checkout-trust-icon" aria-hidden="true">',
            '<svg viewBox="0 0 24 24" fill="none">',
              '<path d="M3.75 7.5h10.5v7.5H3.75z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/>',
              '<path d="M14.25 10.5h3.155a1.5 1.5 0 0 1 1.228.64l1.867 2.61V15h-6.25" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>',
              '<path d="M6.75 18a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm10.5 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z" stroke="currentColor" stroke-width="1.7"/>',
            "</svg>",
          "</span>",
          "<div>",
            "<strong>Shipping shown before you pay</strong>",
            "<span>Shipping charges and applicable taxes are calculated and displayed during checkout.</span>",
          "</div>",
        "</article>",
        '<article class="product-main__checkout-trust-item">',
          '<span class="product-main__checkout-trust-icon" aria-hidden="true">',
            '<svg viewBox="0 0 24 24" fill="none">',
              '<path d="M12 5.25a6.75 6.75 0 1 0 6.75 6.75A6.758 6.758 0 0 0 12 5.25Zm0 3.75v3.375l2.25 1.125" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>',
            "</svg>",
          "</span>",
          "<div>",
            "<strong>Policies are easy to review</strong>",
            "<span>Check shipping and refund details anytime before ordering, or reach out if you want help.</span>",
          "</div>",
        "</article>",
      "</div>"
    ].join("");
  }

  function buildPolicyLinksMarkup() {
    return [
      '<div class="product-main__policy-links">',
        '<a href="/policies/shipping-policy">Shipping policy</a>',
        '<a href="/policies/refund-policy">Refund policy</a>',
        '<a href="/pages/contact">Contact us</a>',
      "</div>"
    ].join("");
  }

  function buildShareSheetMarkup(title, text, url) {
    return [
      '<div class="product-main__share">',
        '<details class="share-sheet" data-share-root data-share-mode="page" data-share-title="', escapeHtml(title), '" data-share-text="', escapeHtml(text), '" data-share-url="', escapeHtml(url), '">',
          '<summary class="button button--secondary share-sheet__summary">',
            '<span class="button__icon share-sheet__summary-icon" aria-hidden="true">',
              '<svg viewBox="0 0 24 24" fill="none" focusable="false" aria-hidden="true">',
                '<path d="M14.25 5.25h4.5v4.5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>',
                '<path d="M10.5 13.5 18.75 5.25" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>',
                '<path d="M18.75 12.75v4.125A1.875 1.875 0 0 1 16.875 18.75H7.125A1.875 1.875 0 0 1 5.25 16.875V7.125A1.875 1.875 0 0 1 7.125 5.25h4.125" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>',
              "</svg>",
            "</span>",
            "<span>Share</span>",
          "</summary>",
          '<div class="share-sheet__menu" role="group" aria-label="Share options">',
            '<button class="share-sheet__option" type="button" data-share-action="native">More options</button>',
            '<button class="share-sheet__option" type="button" data-share-action="copy">Copy link</button>',
            '<button class="share-sheet__option" type="button" data-share-action="email">Email</button>',
            '<button class="share-sheet__option" type="button" data-share-action="text">Text</button>',
            '<button class="share-sheet__option" type="button" data-share-action="whatsapp">WhatsApp</button>',
            '<button class="share-sheet__option" type="button" data-share-action="facebook">Facebook</button>',
            '<button class="share-sheet__option" type="button" data-share-action="twitter">X</button>',
            '<button class="share-sheet__option" type="button" data-share-action="linkedin">LinkedIn</button>',
            '<button class="share-sheet__option" type="button" data-share-action="pinterest">Pinterest</button>',
          "</div>",
          '<p class="u-visually-hidden" data-share-status aria-live="polite"></p>',
        "</details>",
      "</div>"
    ].join("");
  }

  function ensureCheckoutTrust(root) {
    if (!root) return;

    var purchaseCard = root.querySelector(".product-main__purchase-card");
    if (!purchaseCard) return;

    var trustBlock = purchaseCard.querySelector(".product-main__checkout-trust");
    var policyLinks = purchaseCard.querySelector(".product-main__policy-links");
    var reassuranceBlock = purchaseCard.querySelector(".product-main__reassurance");
    var purchaseForm = purchaseCard.querySelector(".product-main__form") || purchaseCard.querySelector("form");

    if (!trustBlock) {
      if (purchaseForm) {
        purchaseForm.insertAdjacentHTML("afterend", buildCheckoutTrustMarkup() + buildPolicyLinksMarkup());
      } else if (reassuranceBlock) {
        reassuranceBlock.insertAdjacentHTML("beforebegin", buildCheckoutTrustMarkup() + buildPolicyLinksMarkup());
      }
      return;
    }

    if (!policyLinks) {
      trustBlock.insertAdjacentHTML("afterend", buildPolicyLinksMarkup());
    }
  }

  function ensureProductShare(root) {
    if (!root) return;

    var purchaseCard = root.querySelector(".product-main__purchase-card");
    if (!purchaseCard || purchaseCard.querySelector(".product-main__share")) return;

    var titleNode = root.querySelector(".product-main__title");
    var excerptNode = root.querySelector("[data-product-short-description]");
    var guideLink = purchaseCard.querySelector(".product-main__guide-link");
    var reassuranceBlock = purchaseCard.querySelector(".product-main__reassurance");
    var shareTitle = titleNode ? titleNode.textContent || "" : document.title || "Wellness Route";
    var shareText = excerptNode ? excerptNode.textContent || shareTitle : shareTitle;
    var shareUrl = window.location.origin + window.location.pathname;
    var shareMarkup = buildShareSheetMarkup(shareTitle, shareText, shareUrl);

    if (guideLink) {
      guideLink.insertAdjacentHTML("afterend", shareMarkup);
    } else if (reassuranceBlock) {
      reassuranceBlock.insertAdjacentHTML("afterend", shareMarkup);
    } else {
      purchaseCard.insertAdjacentHTML("beforeend", shareMarkup);
    }

    if (window.WellnessRoute && typeof window.WellnessRoute.syncShareSheets === "function") {
      window.WellnessRoute.syncShareSheets(root);
    }
  }

  function setupGallery(root) {
    var featuredImage = root.querySelector("[data-product-featured-image]");
    var thumbs = root.querySelectorAll("[data-product-thumb]");
    if (!featuredImage || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var nextSrc = thumb.getAttribute("data-product-thumb-src");
        var nextSrcset = thumb.getAttribute("data-product-thumb-srcset");
        var nextAlt = thumb.getAttribute("data-product-thumb-alt");

        if (nextSrc) featuredImage.setAttribute("src", nextSrc);
        if (nextSrcset) featuredImage.setAttribute("srcset", nextSrcset);
        if (nextAlt) featuredImage.setAttribute("alt", nextAlt);

        thumbs.forEach(function (other) {
          other.classList.toggle("is-active", other === thumb);
        });
      });
    });
  }

  document.querySelectorAll("[data-product-page-root]").forEach(function (root) {
    ensureCheckoutTrust(root);
    ensureProductShare(root);

    var dataNode = root.querySelector("[data-product-page-data]");
    if (!dataNode) return;

    var data;
    try {
      data = JSON.parse(dataNode.textContent || "{}");
    } catch (error) {
      console.error("Unable to parse product page data.", error);
      return;
    }

    var parsed = parseProductContent(data.description_html || "");
    var product = {
      title: data.title || "",
      handle: data.handle || "",
      vendor: data.vendor || "",
      type: data.type || "",
      variant_title: data.variant_title || "",
      tags: Array.isArray(data.tags) ? data.tags : [],
      collections: Array.isArray(data.collections) ? data.collections : [],
      featured: Boolean(data.featured),
      dianas_favourite: Boolean(data.dianas_favourite),
      description_html: data.description_html || ""
    };

    setupGallery(root);

    var shortDescription = buildHeroSummary(parsed, product);
    var benefitItems = buildBenefits(parsed, product);
    var ethics = buildEthics(product);
    var highlights = buildHighlights(parsed, product);
    var leadParagraphs = buildLeadParagraphs(parsed, product);
    var whatItIs = buildWhatItIs(parsed, product);
    var whatItDoes = buildWhatItDoes(parsed, product);
    var whyWePickedIt = buildWhyWePickedIt(product);
    var founderTitle = buildFounderTitle(product);
    var founderNote = buildFounderNote(product);
    var founderStory = buildFounderStory(product);
    var howTo = buildHowTo(parsed, product, data);
    var specsGoodToKnow = buildGoodToKnowItems(parsed, product);
    var accordionGoodToKnow = buildGoodToKnowItems(parsed, product, { includeIncludedItems: true });
    var heroGlance = buildHeroGlance(parsed, product);
    var specs = buildSpecs(parsed, product, specsGoodToKnow);
    var ingredients = buildIngredients(parsed, data, product);
    var productFacts = buildProductFacts(parsed, product, howTo, ingredients, benefitItems);
    var ingredientsPanel = buildIngredientsPanel(parsed, product, data, ingredients);

    var excerptTarget = root.querySelector("[data-product-short-description]");
    if (excerptTarget && shortDescription) {
      excerptTarget.textContent = shortDescription;
    }

    var founderTitleTarget = root.querySelector("[data-product-founder-title]");
    if (founderTitleTarget) {
      founderTitleTarget.textContent = founderTitle;
    }

    var founderNoteTarget = root.querySelector("[data-product-founder-note]");
    if (founderNoteTarget) {
      founderNoteTarget.textContent = founderNote;
    }

    var howToSection = document.querySelector("[data-product-howto-section]");
    if (howToSection) {
      howToSection.hidden = !howTo.length;
    }

    var specsSection = document.querySelector("[data-product-specs-section]");
    if (specsSection) {
      specsSection.hidden = !(productFacts.length || specs.length);
    }

    renderGlance(root.querySelector("[data-product-at-a-glance]"), heroGlance);
    renderBenefits(root.querySelector("[data-product-benefits]"), benefitItems);
    renderEthics(root.querySelector("[data-product-ethics]"), ethics);
    renderHighlights(document.querySelector("[data-product-highlights]"), highlights);
    renderAccordionParagraphs(root.querySelector("[data-product-why-picked]"), whyWePickedIt);
    renderParagraphs(root.querySelector("[data-product-full-description]"), leadParagraphs);
    renderParagraphs(root.querySelector("[data-product-what-it-is]"), whatItIs);
    renderList(root.querySelector("[data-product-what-it-does]"), whatItDoes, "product-story__list");
    renderParagraphs(root.querySelector("[data-product-founder-story]"), founderStory);
    renderHowTo(document.querySelector("[data-product-howto]"), howTo);
    renderProductFacts(document.querySelector("[data-product-facts]"), productFacts);
    renderSpecs(document.querySelector("[data-product-specs]"), specs);
    renderGoodToKnow(root.querySelector("[data-product-good-to-know]"), accordionGoodToKnow.length ? accordionGoodToKnow : specsGoodToKnow);

    var ingredientsSection = document.querySelector("[data-product-ingredients-section]");
    if (ingredients.length) {
      if (ingredientsSection) ingredientsSection.hidden = false;
      renderIngredients(document.querySelector("[data-product-ingredients]"), ingredients);
      renderIngredientsPanel(
        document.querySelector("[data-product-ingredients-copy]"),
        ingredientsPanel,
        document.querySelector("[data-product-ingredients-copy-label]")
      );
    } else if (ingredientsSection) {
      ingredientsSection.hidden = true;
    }
  });
})();
